export const featureFlagKeys = {
  all: ['feature-flags'] as const,
};
